import { TableHeadersType } from '../tableHeadersType';

export const TIMESHEET_UNFILLED_REPORT_HEADERS: TableHeadersType[] = [
  {
    "label": "DATE",
    "value": "date",
  
  },
  {
    "label": "DAY",
    "value": "day",
  },
];